import { LocationDescriptor } from 'history'

/** Hospitals directory — default tab, scroll to browse section */
export const hospitalsBrowseLink: LocationDescriptor = {
  hash: '',
  pathname: '/hospitals/',
  state: { scrollToBrowse: true },
}

/**
 * Agencies directory lives on /hospitals with hash tab=agencies (same as TopNav).
 * No state/city hash params needed unless clearing an active location filter.
 */
export const agenciesBrowseLink: LocationDescriptor = {
  hash: '#tab=agencies',
  pathname: '/hospitals',
  state: { scrollToBrowse: true },
}
